export const PROFILE_PERMISSION = "users:manage_self"
